import moment from 'moment';

export function ParseStringDate(stringDate: string, dateFormat: string) {
    return moment(stringDate, dateFormat).toDate();
}
